import React from "react";
import MessageCTAs from "./MessageCTAs";
import InternalRating from "../../custom/HM/InternalRating";
import StarRating from "../../custom/HM/StarRating";

export default function OfferMessageTemplate({
  template,
  index,
  assistantId,
  threadId,
  isMobile,
}: any) {
  return (
    <div className="message-template" key={index}>
      <div className="message-template-title">
        {index + 1 + ". "}
        {template.offer.title}
      </div>
      <div className="message-template-subtitle">
        {template.offer.sub_title}
      </div>
      <img
        alt="Offer"
        className="message-template-offer-image-main"
        src={template.offer.placeholder_image}
      ></img>
      <div className="message-template-offer-hotel-section">
        <img
          className="message-template-offer-image-hotel"
          alt="Hotel"
          src={template.hotel.placeholder_image}
        ></img>
        <div className="message-template-offer-hotel-info">
          <div className="message-template-offer-hotel-title">
            {template.hotel.title}
            <StarRating stars={template.hotel.stars} />
          </div>
          <div className="message-template-offer-location">
            <span style={{ fontStyle: "normal" }}>📍</span>{" "}
            {template.hotel.location}
          </div>
          {template.hotel.internal_rating && (
            <InternalRating rating={template.hotel.internal_rating} />
          )}
        </div>
      </div>

      <ul className="message-template-details">
        {template.hotel.details?.map((detail: any, detailIndex: any) => (
          <li key={detailIndex}>{detail}</li>
        ))}
      </ul>
      <MessageCTAs
        assistantId={assistantId}
        isMobile={isMobile}
        template={template}
        threadId={threadId}
      />
    </div>
  );
}
